module.exports = __webpack_public_path__ + "static/media/sdmt2.41baa408.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt2.svg
// module id = 342
// module chunks = 0